import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const getKeys = createAsyncThunk(
  'tables/getKeys',
  async (payload, { getState }) => {
    return getState().tables.tables[payload.key]
  }
)

export const tablesSlice = createSlice({
  name: 'tables',
  initialState: {
    tables: {},
  },
  reducers: {
    setTableKeys: (state, action) => {
      if (!state.tables[action.payload.key]) {
        state.tables[action.payload.key] = {
          labels: action.payload.labels,
          keys: action.payload.keys,
        }
      }
    },
  },
})

export const { setTableKeys } = tablesSlice.actions

export default tablesSlice.reducer
